(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["lb-mobile-purchase"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('lb-mobile-purchase')) {
  customElements.define('lb-mobile-purchase', class extends HTMLElement {
    connectedCallback() {
      if (this.initializing) return;
      this.initializing = true;
      const start = async () => {
        this.root = this.closest('[id^="MainProduct-"]');
        if (!this.root || this.closest('quick-add-modal,quick-view-modal')) return;
        this.nativeForm = this.root.querySelector(`form[id="product-form-${this.dataset.sectionId}"]`);
        this.nativeButton = this.nativeForm?.querySelector('[name="add"]');
        this.dialog = this.querySelector('dialog');
        if (!this.nativeButton || typeof this.dialog.showModal !== 'function') return;
        this.picker = this.root.querySelector('variant-radios,variant-selects');
        await customElements.whenDefined('product-form');
        if (this.picker) await customElements.whenDefined(this.picker.localName);
        if (!this.isConnected) return;
        this.init();
      };
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once:true});
      else start();
    }
    init() {
      this.abort = new AbortController();
      const signal = this.abort.signal;
      this.formElement = this.nativeForm.closest('product-form');
      this.formWrapper = this.formElement.parentElement;
      this.errorElement = this.formElement.querySelector('.product-form__error-message');
      this.priceSource = this.root.querySelector(`[id="price-${this.dataset.sectionId}"]`);
      this.action = this.querySelector('[data-lb-action]');
      this.addButton = this.querySelector('[data-lb-add]');
      this.changeButton = this.querySelector('[data-lb-change]');
      this.retryButton = this.querySelector('[data-lb-retry]');
      this.fieldsets = this.picker ? [...this.picker.querySelectorAll('fieldset')] : [];
      this.confirmed = new Set();
      this.moves = [];
      this.mq = window.matchMedia('(max-width:749px)');
      this.available = this.dataset.available === 'true';
      this.variantData = this.picker ? JSON.parse(this.picker.querySelector('[type="application/json"]').textContent) : [];
      const requested = new URL(window.location.href).searchParams.get('variant');
      if (requested === this.dataset.defaultVariant) this.fieldsets.forEach(group => this.confirmed.add(group));
      if (!this.picker) this.action.removeAttribute('aria-haspopup');
      if (this.available) this.action.addEventListener('click', () => this.isConfirmed() ? this.add() : this.open(), {signal});
      this.addButton.addEventListener('click', () => this.add(), {signal});
      this.changeButton.addEventListener('click', () => this.open(), {signal});
      this.querySelector('[data-lb-close]').addEventListener('click', () => this.dialog.close(), {signal});
      this.retryButton.addEventListener('click', () => {
        this.message('');
        this.picker?.dispatchEvent(new Event('change', {bubbles:true}));
      }, {signal});
      this.dialog.addEventListener('click', event => {
        if (event.target !== this.dialog) return;
        const rect = this.dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close();
      }, {signal});
      this.dialog.addEventListener('close', () => this.releaseScroll(), {signal});
      this.picker?.addEventListener('click', event => {
        if (!this.active) return;
        const input = event.target.closest('input[type="radio"]');
        if (!input || input.classList.contains('disabled')) return;
        this.confirmed.add(input.closest('fieldset'));
        this.message('');
        queueMicrotask(() => this.sync());
      }, {signal});
      this.picker?.addEventListener('change', event => {
        if (!this.active) return;
        const group = event.target.closest('fieldset');
        if (group) this.confirmed.add(group);
        this.message('');
        clearTimeout(this.selectionTimer);
        this.selectionTimer = setTimeout(() => {
          if (this.active && this.nativeButton.disabled && this.selectedVariant()?.available) {
            this.message(this.dataset.selectError);
            this.retryButton.hidden = false;
          }
        }, 12000);
        queueMicrotask(() => this.sync());
      }, {signal});
      document.addEventListener('variant:add', event => {
        if (!this.submitting || event.detail?.formElement !== this.nativeForm) return;
        this.success = true;
        this.message('');
        if (this.dialog.open) {
          this.dialog.close();
          this.releaseScroll();
        }
        const cart = document.querySelector('cart-drawer,cart-notification');
        cart?.setActiveElement?.(this.action);
      }, {signal});
      document.addEventListener('cart:error', event => {
        if (!this.submitting || event.detail?.sectionId !== this.dataset.sectionId) return;
        this.failed = true;
        this.message(event.detail.errors || this.dataset.error);
      }, {signal});
      this.observer = new MutationObserver(() => {
        const loading = this.nativeButton.classList.contains('loading') || this.nativeButton.getAttribute('aria-disabled') === 'true';
        if (this.submitting && !loading) {
          if (!this.success && !this.failed) this.message(this.errorElement?.textContent.trim() || this.dataset.error);
          this.submitting = false;
          this.picker?.removeAttribute('inert');
        }
        this.sync();
      });
      this.observer.observe(this.nativeButton, {attributes:true,childList:true,subtree:true});
      if (this.priceSource) this.observer.observe(this.priceSource, {attributes:true,childList:true,subtree:true,characterData:true});
      this.mq.addEventListener('change', () => this.setMobile(this.mq.matches), {signal});
      this.setMobile(this.mq.matches);
    }
    selectedVariant() {
      return this.variantData.find(variant => String(variant.id) === this.nativeForm.querySelector('[name="id"]').value);
    }
    isConfirmed() {
      return !this.picker || this.fieldsets.every(group => this.confirmed.has(group));
    }
    setMobile(mobile) {
      if (mobile === this.active) return;
      this.active = mobile;
      this.dataset.active = String(mobile);
      if (mobile) {
        const pickerWrapper = this.available ? this.picker?.closest('.product-parameters') : null;
        const help = this.available && this.picker ? (this.root.querySelector('.custom-liquid a[href^="viber:"]')?.closest('.custom-liquid') || this.root.querySelector('lb-size-guide')?.closest('.custom-liquid')) : null;
        for (const [node, slot] of [[pickerWrapper, '[data-lb-picker-slot]'],[help, '[data-lb-help-slot]']]) {
          if (!node) continue;
          const placeholder = document.createElement('span');
          placeholder.hidden = true;
          node.before(placeholder);
          this.moves.push({node,placeholder});
          this.querySelector(slot).append(node);
        }
        if (this.available && this.picker && this.fieldsets.length === 1 && !this.isConfirmed()) {
          this.picker.querySelectorAll('input[type="radio"]').forEach(input => {input.checked = false;});
        }
        this.formWrapper.classList.add('lb-purchase-native-hidden');
        document.body.classList.add('lb-purchase-enabled');
        this.hidden = false;
        this.sync();
      } else {
        this.closeDialogs();
        this.moves.forEach(({node,placeholder}) => {placeholder.replaceWith(node);});
        this.moves = [];
        this.formWrapper.classList.remove('lb-purchase-native-hidden');
        document.body.classList.remove('lb-purchase-enabled');
        this.hidden = true;
        const selected = this.selectedVariant();
        if (selected) this.fieldsets.forEach((group,index) => {
          const input = [...group.querySelectorAll('input[type="radio"]')].find(input => input.value === selected[`option${index + 1}`]);
          if (input) input.checked = true;
        });
      }
    }
    sync() {
      if (!this.active) return;
      if (!this.available) {
        this.syncSoldOut();
        return;
      }
      const confirmed = this.isConfirmed();
      const variant = this.selectedVariant();
      const valid = this.picker ? !!variant?.available && !this.fieldsets.some(group => group.querySelector('input:checked.disabled')) : this.available;
      const busy = !!this.submitting;
      const loading = confirmed && valid && this.nativeButton.disabled;
      const text = !this.available ? this.dataset.soldOut : busy || loading ? this.dataset.loading : confirmed && valid ? this.dataset.add : this.dataset.choose;
      this.action.textContent = text;
      this.addButton.textContent = text;
      this.action.disabled = !this.available || busy || loading;
      this.addButton.disabled = !this.available || !confirmed || !valid || this.nativeButton.disabled || busy;
      this.action.setAttribute('aria-busy', String(busy || loading));
      this.addButton.setAttribute('aria-busy', String(busy || loading));
      this.changeButton.hidden = !this.picker || !confirmed;
      this.changeButton.textContent = variant ? `${this.dataset.selected}: ${variant.title}` : this.dataset.choose;
      this.changeButton.disabled = busy;
      if (!this.nativeButton.disabled) {
        clearTimeout(this.selectionTimer);
        this.retryButton.hidden = true;
      }
      if (this.priceSource) {
        const price = this.priceSource.querySelector('.price');
        const amount = price?.querySelector(price.classList.contains('price--on-sale') ? '.price-item--sale' : '.price__regular .price-item--regular');
        if (amount) this.querySelectorAll('[data-lb-price]').forEach(element => {element.textContent = amount.textContent.trim();});
      }
      if (this.submitting) this.picker?.setAttribute('inert','');
      else this.picker?.removeAttribute('inert');
    }
    syncSoldOut() {
      const block = this.root.querySelector('[data-lb-sold-out]');
      const category = block?.querySelector('[data-lb-category-link]');
      const categoryHref = category?.getAttribute('href');
      const categoryOnly = block?.dataset.lbHasAlternatives === 'false' && categoryHref;
      this.action.setAttribute('href', categoryOnly ? categoryHref : `#LBSoldOut-${this.dataset.sectionId}`);
      this.action.textContent = categoryOnly ? this.dataset.viewCategory : this.dataset.viewSimilar;
      this.action.removeAttribute('aria-busy');
      this.action.removeAttribute('aria-expanded');
      this.changeButton.hidden = true;
      this.addButton.disabled = true;
    }
    message(text) {
      this.querySelectorAll('[data-lb-bar-status],[data-lb-sheet-status]').forEach(element => {
        element.textContent = text;
        element.hidden = !text;
      });
    }
    open() {
      if (!this.active || !this.available || this.dialog.open || this.submitting) return;
      this.scrollLock = {overflow:document.documentElement.style.overflow};
      document.documentElement.style.overflow = 'hidden';
      this.dialog.showModal();
      this.action.setAttribute('aria-expanded','true');
    }
    releaseScroll() {
      if (this.scrollLock) {
        document.documentElement.style.overflow = this.scrollLock.overflow;
        this.scrollLock = null;
      }
      this.action?.setAttribute('aria-expanded','false');
    }
    closeDialogs() {
      this.querySelectorAll('lb-size-guide dialog[open]').forEach(dialog => dialog.close());
      this.querySelectorAll('lb-size-guide').forEach(guide => guide.restoreScroll?.());
      if (this.dialog?.open) this.dialog.close();
      this.releaseScroll();
    }
    add() {
      if (!this.active || this.submitting || !this.available) return;
      if (!this.isConfirmed()) {this.open();return;}
      if (this.picker && !this.selectedVariant()?.available) {this.open();return;}
      if (this.nativeButton.disabled || this.nativeButton.getAttribute('aria-disabled') === 'true') return;
      this.submitting = true;
      this.success = false;
      this.failed = false;
      this.message('');
      this.sync();
      this.nativeButton.click();
    }
    disconnectedCallback() {
      this.closeDialogs();
      clearTimeout(this.selectionTimer);
      this.observer?.disconnect();
      this.abort?.abort();
      this.moves?.forEach(({node,placeholder}) => {if (placeholder.isConnected) placeholder.replaceWith(node);});
      this.formWrapper?.classList.remove('lb-purchase-native-hidden');
      if (this.active) document.body.classList.remove('lb-purchase-enabled');
      this.initializing = false;
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["lb-product-reviews"] && !Shopify.designMode) return;
  try {
    (() => {
    if (customElements.get('lb-product-reviews')) return;
    let railId = 0;
    const isReview = (card) => card.matches('.jdgm-rev') && !card.hidden && getComputedStyle(card).display !== 'none';

    class ReviewRail {
      constructor(list, labels) {
        this.list = list;
        this.cards = [];
        this.index = 0;
        this.originalHeight = list.style.height;
        this.originalTabindex = list.getAttribute('tabindex');
        this.originalLabel = list.getAttribute('aria-label');
        this.originalRole = list.getAttribute('role');
        this.addedId = !list.id;
        if (this.addedId) list.id = `lb-review-track-${++railId}`;
        list.classList.add('lb-review-track');
        list.setAttribute('tabindex', '0');
        list.setAttribute('aria-label', labels.label);
        if (!this.originalRole) list.setAttribute('role', 'region');

        this.navigation = document.createElement('div');
        this.navigation.className = 'lb-review-navigation';
        this.navigation.hidden = true;
        this.navigation.setAttribute('role', 'group');
        this.navigation.setAttribute('aria-label', labels.label);
        this.previous = this.button(labels.previous, '←', -1);
        this.next = this.button(labels.next, '→', 1);
        this.position = document.createElement('span');
        this.position.className = 'lb-review-position';
        this.position.setAttribute('aria-live', 'polite');
        this.position.setAttribute('aria-atomic', 'true');
        this.navigation.append(this.previous, this.position, this.next);
        list.after(this.navigation);

        this.onScroll = () => this.scheduleUpdate();
        this.onKey = (event) => {
          if (event.target !== list) return;
          const rtl = getComputedStyle(list).direction === 'rtl';
          let nextIndex;
          if (event.key === 'ArrowRight') nextIndex = this.index + (rtl ? -1 : 1);
          if (event.key === 'ArrowLeft') nextIndex = this.index + (rtl ? 1 : -1);
          if (event.key === 'Home') nextIndex = 0;
          if (event.key === 'End') nextIndex = this.cards.length - 1;
          if (nextIndex === undefined) return;
          event.preventDefault();
          this.move(nextIndex);
        };
        list.addEventListener('scroll', this.onScroll, { passive: true });
        list.addEventListener('keydown', this.onKey);
        this.resizeObserver = new ResizeObserver(() => this.scheduleUpdate());
        this.cardObserver = new MutationObserver((records) => {
          if (records.some((record) => record.target.parentElement === list && record.target.matches('.jdgm-rev'))) {
            this.refresh();
            this.scheduleUpdate();
          }
        });
        this.cardObserver.observe(list, { attributes: true, attributeFilter: ['class', 'style', 'hidden'], subtree: true });
        this.refresh();
      }

      button(label, symbol, step) {
        const button = document.createElement('button');
        button.type = 'button';
        button.setAttribute('aria-label', label);
        button.setAttribute('aria-controls', this.list.id);
        button.textContent = symbol;
        button.addEventListener('click', () => this.move(this.index + step));
        return button;
      }

      refresh() {
        const cards = Array.from(this.list.children).filter(isReview);
        const changed = cards.length !== this.cards.length || cards.some((card, i) => card !== this.cards[i]);
        if (!changed) return;
        const appended = this.cards.length > 0 && this.cards.every((card, i) => cards[i] === card);
        this.resizeObserver.disconnect();
        this.cards = cards;
        for (const card of cards) this.resizeObserver.observe(card);
        this.navigation.hidden = cards.length < 2;
        if (!appended) {
          this.index = 0;
          this.list.scrollTo({ left: 0, behavior: 'instant' });
        }
        this.update();
      }

      scheduleUpdate() {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => {
          this.frame = null;
          this.update();
        });
      }

      update() {
        if (!this.cards.length) {
          this.list.style.height = this.originalHeight;
          return;
        }
        if (!this.list.clientWidth) return;
        const left = this.list.getBoundingClientRect().left;
        let closest = Infinity;
        this.cards.forEach((card, index) => {
          const distance = Math.abs(card.getBoundingClientRect().left - left);
          if (distance < closest) {
            closest = distance;
            this.index = index;
          }
        });
        const height = `${Math.ceil(this.cards[this.index].getBoundingClientRect().height) + 2}px`;
        if (this.list.style.height !== height) this.list.style.height = height;
        this.previous.disabled = this.index === 0;
        this.next.disabled = this.index === this.cards.length - 1;
        const position = `${this.index + 1} / ${this.cards.length}`;
        if (this.position.textContent !== position) this.position.textContent = position;
      }

      move(index) {
        const card = this.cards[Math.max(0, Math.min(this.cards.length - 1, index))];
        if (!card) return;
        const left = card.getBoundingClientRect().left - this.list.getBoundingClientRect().left;
        this.list.scrollBy({
          left,
          behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'
        });
      }

      destroy() {
        this.resizeObserver.disconnect();
        this.cardObserver.disconnect();
        cancelAnimationFrame(this.frame);
        this.list.removeEventListener('scroll', this.onScroll);
        this.list.removeEventListener('keydown', this.onKey);
        this.list.classList.remove('lb-review-track');
        this.list.style.height = this.originalHeight;
        for (const [name, value] of [['tabindex', this.originalTabindex], ['aria-label', this.originalLabel], ['role', this.originalRole]]) {
          if (value === null) this.list.removeAttribute(name);
          else this.list.setAttribute(name, value);
        }
        if (this.addedId) this.list.removeAttribute('id');
        this.navigation.remove();
      }
    }

    class ProductReviews extends HTMLElement {
      connectedCallback() {
        this.rails = new Map();
        this.mount = () => {
          this.main = document.getElementById('MainContent');
          if (!this.main || !this.isConnected) return;
          this.observer = new MutationObserver(() => {
            if (this.frame) return;
            this.frame = requestAnimationFrame(() => {
              this.frame = null;
              this.sync();
            });
          });
          this.observer.observe(this.main, { childList: true, subtree: true });
          this.sync();
        };
        if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', this.mount, { once: true });
        else this.mount();
      }

      sync() {
        const lists = new Set();
        for (const widget of this.main.querySelectorAll('.jdgm-review-widget[data-id]:not([data-id=""])')) {
          const list = widget.querySelector('.jdgm-rev-widg__body > .jdgm-rev-widg__reviews');
          if (list && Array.from(list.children).some((card) => card.matches('.jdgm-rev'))) lists.add(list);
        }
        for (const [list, rail] of this.rails) {
          if (!lists.has(list)) {
            rail.destroy();
            this.rails.delete(list);
          }
        }
        for (const list of lists) {
          if (this.rails.has(list)) this.rails.get(list).refresh();
          else this.rails.set(list, new ReviewRail(list, this.dataset));
        }
      }

      disconnectedCallback() {
        document.removeEventListener('DOMContentLoaded', this.mount);
        this.observer?.disconnect();
        cancelAnimationFrame(this.frame);
        for (const rail of this.rails.values()) rail.destroy();
        this.rails.clear();
      }
    }

    customElements.define('lb-product-reviews', ProductReviews);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["lb-size-guide"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('lb-size-guide')) {
  customElements.define('lb-size-guide', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) return;
      const fallback = this.querySelector('.lb-guide');
      if (!fallback) {
        if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => this.connectedCallback(), { once: true });
        return;
      }
      const panel = fallback.querySelector('.lb-guide__panel');
      const dialog = this.querySelector('.lb-guide-drawer');
      const trigger = this.querySelector('[data-lb-guide-open]');
      if (typeof dialog.showModal !== 'function') return;
      this.querySelector('.guide-mode').hidden = false;
      if (window.matchMedia('(max-width:600px)').matches) {
        const firstSize = panel.querySelector('details.size-card');
        const help = panel.querySelector('.lb-guide__help');
        if (firstSize) firstSize.open = true;
        if (help) help.open = true;
      }
      this.addEventListener('click', event => {
        const button = event.target.closest('[data-guide-mode]');
        if (!button || !this.contains(button)) return;
        const cards = button.dataset.guideMode === 'cards';
        panel.querySelector('.size-cards').hidden = !cards;
        panel.querySelector('.all-measurements').hidden = cards;
        panel.querySelector('.guide-hint').hidden = !cards || Number(this.dataset.metrics) < 1;
        panel.querySelectorAll('[data-guide-mode]').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
      });
      this.dataset.ready = 'true';
      this.dialog = dialog;
      dialog.querySelector('.lb-guide-drawer__body').append(panel);
      fallback.hidden = true;
      trigger.hidden = false;
      const restoreScroll = () => {
        if (!this.scrollLock) return;
        document.documentElement.style.overflow = this.scrollLock.overflow;
        document.documentElement.style.paddingRight = this.scrollLock.paddingRight;
        this.scrollLock = null;
      };
      this.restoreScroll = restoreScroll;
      trigger.addEventListener('click', () => {
        if (dialog.open) return;
        if (window.matchMedia('(max-width:600px)').matches && !this.mobileOpened) {
          const firstSize = panel.querySelector('details.size-card');
          const help = panel.querySelector('.lb-guide__help');
          if (firstSize) firstSize.open = true;
          if (help) help.open = true;
          this.mobileOpened = true;
        }
        const root = document.documentElement;
        const style = getComputedStyle(root);
        const scrollbar = window.innerWidth - root.clientWidth;
        this.scrollLock = { overflow: root.style.overflow, paddingRight: root.style.paddingRight };
        root.style.overflow = 'hidden';
        if (scrollbar > 0 && !style.scrollbarGutter.includes('stable')) {
          root.style.paddingRight = `${parseFloat(style.paddingRight) + scrollbar}px`;
        }
        dialog.showModal();
      });
      dialog.querySelectorAll('[data-lb-guide-close]').forEach(button => {
        button.hidden = false;
        button.addEventListener('click', () => dialog.close());
      });
      dialog.addEventListener('click', event => {
        if (event.target !== dialog) return;
        const bounds = dialog.getBoundingClientRect();
        if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
      });
      dialog.addEventListener('keydown', event => {
        if (event.key !== 'Tab') return;
        const focusable = [...dialog.querySelectorAll('button, a[href], input, select, textarea, summary, [tabindex]:not([tabindex="-1"])')].filter(element => !element.disabled && element.getClientRects().length && getComputedStyle(element).visibility !== 'hidden');
        const first = focusable[0];
        const last = focusable[focusable.length - 1];
        if (!first) return;
        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      });
      dialog.addEventListener('close', () => {
        restoreScroll();
        if (trigger.isConnected) trigger.focus({ preventScroll: true });
      });
    }
    disconnectedCallback() {
      if (this.dialog?.open) this.dialog.close();
      this.restoreScroll?.();
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
